import { memo, type JSX } from 'react';

import { NavItem } from '../SubNavLayout/SubNavLayout';
import type { CollapsibleTabItem } from '../CollapsibleTabs';
import styles from './SectionSidebar.module.css';

interface SectionSidebarProps {
  items: CollapsibleTabItem[];
  activeItem: string;
  onItemChange: (id: string) => void;
}

export const SectionSidebar = memo(function SectionSidebar({
  items,
  activeItem,
  onItemChange,
}: SectionSidebarProps): JSX.Element {
  return (
    <nav className={styles.sidebar}>
      <div className={styles.navItems}>
        {items.map((item) => (
          <NavItem
            key={item.id}
            item={item}
            isActive={item.id === activeItem}
            onClick={onItemChange}
          />
        ))}
      </div>
    </nav>
  );
});
